export const locale = {
    'DIALOG': {
        'SUPPLIER_PRIORITY': {
            'TITLE': 'Порядок поставщиков',
            'CONFIRMBUTTON': 'Сохранить',
            'NAME': 'Название',
        },
    }
}